export default "__VITE_ASSET__BuevF_ZN__"